import { render } from "./SessionNewComponent.vue?vue&type=template&id=1ad624af&scoped=true"
import script from "./SessionNewComponent.vue?vue&type=script&lang=js"
export * from "./SessionNewComponent.vue?vue&type=script&lang=js"

import "./SessionNewComponent.vue?vue&type=style&index=0&id=1ad624af&scoped=true&lang=css"

import exportComponent from "/Users/apiffare/projects/aldes/apps/aldes-learning-support-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad624af"]])

export default __exports__